(function () {
  "use strict";

  angular
    .module("admin.posts.service", [])
    .factory("PostsAdminService", PostsAdminService);

  /** @ngInject */
  function PostsAdminService($http, $q, API) {
    function listPublished(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/admin_posts/published?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listEventPublished(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/community_posts/published?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listDraft(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/admin_posts/unpublished?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listEventDraft(start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/community_posts/unpublished?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function save(model) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/admin_posts", model)
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, "", "error");
        });

      return defered.promise;
    }

    function get(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/posts/" + id)
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, "", "error");
        });

      return defered.promise;
    }

    function update(id, model) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/admin_posts/" + id, model)
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, "", "error");
        });

      return defered.promise;
    }

    function remove(id) {
      var defered = $q.defer();

      $http
        .delete(API.API_URL + "admin/admin_posts/" + id)
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, "", "error");
        });

      return defered.promise;
    }

    function clone(id) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/admin_posts/" + id + "/clone")
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, "", "error");
        });

      return defered.promise;
    }

    function publish(id) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/posts/" + id + "/publish")
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, "", "error");
        });

      return defered.promise;
    }

    function unpublish(id) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/posts/" + id + "/unpublish")
        .success(defered.resolve)
        .error(function (result) {
          swal(result.error.message, "", "error");
        });

      return defered.promise;
    }

    function listPostSegmentation(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/admin_posts/" + id + "/user_segments")
        .success(defered.resolve);

      return defered.promise;
    }

    function listPostSegmentationUsers(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/admin_posts/" + id + "/user_segmenter_users")
        .success(defered.resolve);

      return defered.promise;
    }

    function listSegmentation() {
      var defered = $q.defer();

      $http.get(API.API_URL + "admin/user_segments").success(defered.resolve);

      return defered.promise;
    }

    function addPostSegmentation(id, segmentId) {
      var defered = $q.defer();

      $http
        .post(
          API.API_URL +
            "admin/admin_posts/" +
            id +
            "/user_segments/" +
            segmentId
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removePostSegmentation(id, segmentId) {
      var defered = $q.defer();

      $http
        .delete(
          API.API_URL +
            "admin/admin_posts/" +
            id +
            "/user_segments/" +
            segmentId
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function reorder(id, order) {
      var defered = $q.defer();

      $http
        .put(API.API_URL + "admin/admin_posts/" + id + "/order/" + order)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function hide(id) {
      var defer = $q.defer();

      $http
        .post(API.API_URL + "admin/posts/" + id + "/hide")
        .success(defer.resolve)
        .error(defer.reject);

      return defer.promise;
    }

    function listPostBlockedUsers(id, start, limit) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/posts/" +
            id +
            "/blocked_users?start=" +
            start +
            "&limit=" +
            limit
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listPostBlockedUserComments(id, start, limit, sort) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/posts/" +
            id +
            "/blocked_user_comments?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=" +
            sort
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return {
      listPublished: listPublished,
      listDraft: listDraft,
      listEventPublished: listEventPublished,
      listEventDraft: listEventDraft,
      get: get,
      save: save,
      update: update,
      remove: remove,
      clone: clone,
      publish: publish,
      unpublish: unpublish,
      listPostSegmentation: listPostSegmentation,
      listPostSegmentationUsers: listPostSegmentationUsers,
      listSegmentation: listSegmentation,
      addPostSegmentation: addPostSegmentation,
      removePostSegmentation: removePostSegmentation,
      reorder: reorder,
      hide: hide,
      listPostBlockedUsers: listPostBlockedUsers,
      listPostBlockedUserComments: listPostBlockedUserComments,
    };
  }
})();
